import toast from "react-hot-toast"
import styled from "styled-components"

export const NotificationType = {
    SUCCESS: ["is-primary", "fa-check-square", "has-text-primary"],
    ERROR: ["is-danger", "fa-ban", "has-text-danger"],
    INFO: ["is-info", "fa-info-circle", "has-text-info"],
    WARNING: ["is-warning", "fa-exclamation-triangle", "has-text-warning"],
    // DEFAULT: "default",
};

interface NotificationStyleClasses {
    styleClassName?: string;
    iconClassName?: string;
    iconTextClassName?: string;
}

const getNotificationStyle = (type?: string[]): NotificationStyleClasses => {
    if (type && type.length === 3) {
        return {
            styleClassName: type[0],
            iconClassName: type[1],
            iconTextClassName: type[2]
        };
    }
    type = NotificationType.INFO;
    return {
        styleClassName: type[0],
        iconClassName: type[1],
        iconTextClassName: type[2]
    };
}

export const showNotification = (message: string, type: string[] = NotificationType.ERROR, title?: string) => {
    const notificationStyle = getNotificationStyle(type);
    // padding: 10px;
    // width: 230px;
    // min-height: 60px;
    // display: flex;
    // align-items: center;
    toast.custom((t) => {
        return (
            <NotificationBox className={`notification ${notificationStyle.styleClassName}`}>
                <button className="delete" style={{margin: 5}} onClick={() => toast.dismiss(t.id)}/>
                <span className="icon-text">
                    <span className={`icon`}>
                        <i className={`fas ${notificationStyle.iconClassName}`}/>
                    </span>
                    <span>{message || "오류가 발생하였습니다"}</span>
                </span>
            </NotificationBox>
        );
    });
};

export const notificationError = (message: string) => {
    showNotification(message, NotificationType.ERROR);
};

export const notificationInfo = (message: string) => {
    showNotification(message, NotificationType.INFO);
};

export const notificationWarning = (message: string) => {
    showNotification(message, NotificationType.WARNING);
};

export const notificationSuccess = (message: string) => {
    showNotification(message, NotificationType.SUCCESS);
}

const NotificationBox = styled.div`
  padding: 10px;
  width: 230px;
  min-height: 60px;
  display: flex;
  align-items: center;
`;
